<template>
    <div>

        <!--<div v-if="isEditor && isVisible" :style="style" style="width: 350px;"
             id="colorPickerElement" @mousedown="stopMousedownPropagation"> -->
      <Modal v-model="modal" title="Local Transport" draggable width="450" footer-hide>
            <div v-if="order">
              <div>
                <ul style="list-style: none; font-size: 14px">
                  <li>
                    <h3>{{order.orderNumber}}</h3> <span style="float: right;margin-top: -20px;font-weight: bold;color: green;">{{order.internalStatus.name}}</span>
                  </li>
                  <li style="display: flex; margin-top: 10px;">
                    <h4>{{order.pickuppartyobject.address[0].city}} </h4>
                    <i class="fas fa-exchange-alt exchange-icon" ></i>
                    <h4>{{order.droppingpartyobject.address[0].city}} </h4>
                  </li>
                  <li style="display: flex; margin-top: 10px;">
                    <span style="color: #a9a9a9; margin-right: 4px;">Client</span>:
                    {{hotInstance.getDataAtRowProp(row, 'clientName')}}
                  </li>
                  <li style="display: flex; margin-top: 10px;">
                    <span style="color: #a9a9a9; margin-right: 4px;">Pickup</span>:
                    {{hotInstance.getDataAtRowProp(row, 'pickupPartyName')}} ( {{order.pickupAreaGroup}} )<br>
                    &nbsp; {{pickupPartyAddress}}
                  </li>
                </ul>
              </div>
              <Divider />
              <div>
                <Button @click.stop="onAssignVehicle(order)" v-if="!showVehicle" style="margin: 0 0 0 15px;">
                    {{order.orderDetails.pickupVehicleAssignId?'Change':'Assign'}} Tempo
                </Button>
                <template v-if="order.orderDetails.pickupVehicleAssignId">
                  {{hotInstance.getDataAtRowProp(row, 'tempoPlateNumber')}}
                  <!--------- Commented temporarily ------------- -->
                  <Button @click="unlinkTempo(order.id, order.orderDetails.id, order.internalstatus)" type="error" :loader="loader1" style="margin: 0 0 0 15px">
                    <span v-if="!loader1">Unlink Tempo</span>
                    <span v-else>Loading...</span>
                  </Button>
                  <!-- -------------x----------------x--------x--- -->
                </template>
                <p v-if="errMessage" style="color: red">{{errMessage}}</p>
                <vehicle-assignment :orderId="order.id" :isComponentLoadedInToDo="true" style="margin: 20px 0 0 0;max-height: 300px;overflow: auto"
                                    v-if="showVehicle" :toDoStage="toDoStage"></vehicle-assignment>
              </div>
            </div>
      </Modal>
        <!-- </div> -->

<!--        <div v-if="isRenderer" style="text-align: center">-->
<!--            <p>{{value}}</p>-->
<!--            <p style="color: #999999" v-if="$parent.$parent.$parent.orders[row]">-->
<!--               <template v-if="$parent.$parent.$parent.orders[row].orderDetails&&-->
<!--                               $parent.$parent.$parent.orders[row].orderDetails.PIckupTempo">-->
<!--                  {{$parent.$parent.$parent.orders[row].orderDetails.PIckupTempo.driverDetail.name}}</template>-->
<!--               <template v-else-if="$parent.$parent.$parent.orders[row].orderDetails&&-->
<!--                                    $parent.$parent.$parent.orders[row].orderDetails.PickupTruck">-->
<!--                  {{$parent.$parent.$parent.orders[row].orderDetails.PickupTruck.driverDetail.name}}</template>-->
<!--                <template v-else>-->
<!--                  <i class="fas fa-plus-circle" style="font-size: 24px; color: #c3c3c3;"></i>-->
<!--                </template>-->
<!--            </p>-->
<!--        </div>-->

    </div>
</template>

<script>
    import {BaseEditorComponent} from '@handsontable/vue'
    import {Constants} from "../../Constants/Constant"
    import VehicleAssignment from "../Manage Order/VehicleAssignment";
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders"
    import moment from "moment";
    import {getAddressString} from "./RendererFunctions";

    export default {
        name: "LocalVehiclePopup",
        components: {VehicleAssignment},
        extends: BaseEditorComponent,
        provide() {
            return {
                getManageOrderDrawer: () => this.manageOrderDrawer,
                setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
                getOrder: () => this.order,
                closeAssignVehicleDialog: (data) => { this.isVisible = data; this.finishEditing() },
            }
        },
        data:function () {
            return{
                Constants: Constants,
                userObj: JSON.parse(localStorage.getItem('tatkalorri')).userObj,
                modal: false,
                order: null,
                hotInstance: null,
                TD: null,
                row: null,
                col: null,
                prop: null,
                originalValue: null,
                value: '',
                cellProperties: null,
                isVisible: false,
                isEditor: null,
                isRenderer: null,
                editorElement: null,
                style: {
                    position: "absolute",
                    padding: "15px",
                    background: "#fff",
                    zIndex: 999,
                    border: "1px solid #000",
                    left: "0px",
                    top: "0px"
                },
                loader1: false,
                showVehicle: false,
                toDoStage: 'assign_local_transport',
                errMessage: ''
            }
        },
        computed: {
          pickupPartyAddress: function(){
            if(this.order?.orderDetails.pickupPoint.pickupPartyId){
              return getAddressString(this.order.orderDetails.pickupPoint)
            }else if(this.order){
              return getAddressString(this.order.pickuppartyobject.address[0])
            }
          }
        },
        methods:{
            stopMousedownPropagation: function(e) {
                e.stopPropagation();
            },
            prepare: function(row, col, prop, td, originalValue, cellProperties) {
                BaseEditorComponent.options.methods.prepare.call(this, row, col, prop, td, originalValue, cellProperties);
                const tdPosition = td.getBoundingClientRect();

                this.style.left = tdPosition.left + window.pageXOffset + 'px';
                this.style.top = tdPosition.top + window.pageYOffset + 'px';
            },
            open: function() {
                this.modal = true
                this.showVehicle = false
                this.errMessage = ''
                this.isVisible = true
                let screen = this.$parent.$parent.$parent.screen
                let ordersVariable = screen + '_orders'
                let pRow = this.hotInstance.toPhysicalRow(this.row)                             //When accessing original array
                this.order = this.$parent.$parent.$parent[ordersVariable][pRow]
            },
            focus: function() {
                this.isVisible = true;
            },
            close: function() {
                this.isVisible = false;
            },
            closeModal: function() {
              // this.showVehicle = false
              this.modal = false;
            },
            setValue: function(value) {
                this.value = value;
            },
            getValue: function() {
                return this.value;
            },
            async unlinkTempo(orderId, orderDetailId, stage){
                let obj = { pickupVehicleAssignId: null}
                await this.updateRecord(orderDetailId, obj, 'orderDetails', 'loader1')

                /* -------- Change Order status to 'Under Pickup Process' --------- */
                if([Constants.internalStatus.readyForPickup, Constants.internalStatus.tempoOnTheWayToPickupLoad, Constants.internalStatus.tempoWaitingForLoadingMaterial,
                    Constants.internalStatus.underBillingProcess, Constants.internalStatus.onTheWayToPickupCityWarehouse,
                    Constants.internalStatus.underVerificationAtPickupCityWarehouse].includes(stage)){
                    obj = { internalstatus: Constants.internalStatus.underPickupProcess, lastStageUpdatedOn : moment().format(),
                            lastStageUpdatedBy : this.userObj.user.id }
                    this.updateRecord(orderId, obj, 'orders', 'loader1')
                }
                /* ----------------x--------------------x---------------x------------- */
            },
            async updateRecord(id, obj, table, loaderStr){
                this[loaderStr] = true
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: { id: id, obj: obj}
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!')
                    this[loaderStr] = false
                    this.close()
                    this.closeModal()
                    this.finishEditing()
                }
            },
            onAssignVehicle(order){
                if(order.internalstatus === Constants.internalStatus.pendingForApproval){
                    this.errMessage = 'Pending For Approval'
                }else if(order.orderDetails.pickupConfirmation === 'Awaiting'){
                    this.errMessage = 'Order Details Confirmation Pending'
                }else if(!order.orderDetails.orderReadiness.isOrderReady){
                    this.errMessage = 'Order not Ready'
                // }else if(!order.orderDetails.lrObject.isEmailSent){
                //     this.errMessage = 'Pending For Pickup Email'
                }else{
                    this.showVehicle = true
                }
            }
        },
    }
</script>

<style scoped>

</style>
